const { CryptoJS } = require("../../kabala3rd/crypto");
const Map = require("./map");

/*** kabala鉴权http签名方法，依赖common.const.js中的相关工具函数:加密、URLencode、hashmap、regExp对象 ****/
const $khttpsignature = {
  getCanonicalizedResource: function (url, params) {
    if (url == null || url == undefined || url.length == 0) return null;

    //从url中截取出uri和search
    var uri = "";
    var search = null;
    var href = url.replace(/^(http|https|ws|wss):\/\/([^/:]+)(:\d*)?\//, "/");

    if (href.indexOf("?") > 0) {
      uri = href.substring(0, href.indexOf("?"));
      search = href.substring(href.indexOf("?") + 1);
    } else {
      uri = href;
    }

    //计算canonicalizedResource
    var canonicalizedResource = uri;
    var paramsMap = new Map();
    var param_keys = [];

    //先获取url中带的参数(不鼓励直接在url中带参)
    while (search != null && search.length > 0) {
      var paramData = "";
      var queryindex = search.indexOf("&");
      if (queryindex > 0) {
        paramData = search.substring(0, queryindex);
        search = search.substring(queryindex + 1);
      } else {
        paramData = search;
        search = "";
      }
      if (paramData == null || paramData.length == 0) continue;
      var paramindex = paramData.indexOf("=");
      if (paramindex <= 0) continue;

      var paramKey = paramData.substring(0, paramindex);
      var paramValue = paramData.substring(paramindex + 1);
      if (
        paramValue == undefined ||
        paramValue == null ||
        paramValue.length == 0
      ) {
        continue;
      }
      paramsMap.put(paramKey, decodeURIComponent(paramValue));
      param_keys.push(paramKey);
    }
    //再获取手动传入的参数
    if (params != null || params != undefined) {
      for (var key in params) {
        if (
          params[key] == undefined ||
          params[key] == null ||
          params[key].length == 0
        ) {
          continue;
        }
        paramsMap.put(key, params[key]);
        param_keys.push(key);
      }
    }
    //拼接有效的search
    if (param_keys.length > 0) {
      param_keys.sort();
      for (var i = 0; i < param_keys.length; i++) {
        if (i == 0) canonicalizedResource += "?";
        else canonicalizedResource += "&";
        canonicalizedResource +=
          param_keys[i] + "=" + paramsMap.get(param_keys[i]);
      }
    }
    return canonicalizedResource;
  },
  getSignature: function (verb, date, canonicalizedResource, secret) {
    var signature = CryptoJS.HmacSHA1(
      verb.toUpperCase() + "\n" + canonicalizedResource + "\n" + date,
      secret
    );
    return CryptoJS.enc.Base64.stringify(signature);
  },
  buildHeader: function (accesskey, verb, url, params) {
    //header签名
    //GMT格式时间 (Thu, 17 Mar 2012 18:49:58 GMT)
    //注意时间差校对（按 accesskey 中记录的服务器时间(systime) 和本地时间 (localtime) 进行纠偏）
    var offsetseconds = parseInt(accesskey.localtime - accesskey.accesskeytime);
    var time = new Date();
    time.setTime(time.getTime() - offsetseconds * 1000); //这是服务器当前时间...
    var gmtdate = time.toGMTString();
    var accesskeyid = accesskey.accesskeyid;
    var domain = accesskey.accessdomain;
    //规范化的请求资源
    var canonicalizedResource = $khttpsignature.getCanonicalizedResource(
      url,
      params
    );
    //签名字符串
    var signature = $khttpsignature.getSignature(
      verb,
      gmtdate,
      canonicalizedResource,
      accesskey.accesskeysecret
    );
    var headers = {
      "x-date": gmtdate,
      "x-authorization": domain + " " + accesskeyid + ":" + signature,
    };
    return headers;
  },
  buildUrlParams: function (accesskey, verb, url) {
    //URL签名
    var offsetseconds = parseInt(accesskey.localtime - accesskey.accesskeytime);
    var time = new Date().getTime();
    var expires = parseInt(time / 1000) - offsetseconds + 120; //过期时间（精确到秒，按服务器时间来算）
    var accesskeyid = accesskey.accesskeyid;
    //规范化的请求资源
    var canonicalizedResource = $khttpsignature.getCanonicalizedResource(
      url,
      null
    );
    //签名字符串
    var signature = $khttpsignature.getSignature(
      verb,
      expires,
      canonicalizedResource,
      accesskey.accesskeysecret
    );
    var params = {
      accessdomain: accesskey.accessdomain,
      accesskey: accesskeyid,
      signature: signature,
      expires: expires,
    };
    return params;
  },
};

module.exports = $khttpsignature;
